<div class="btn-acoes">
  <label for="card-feed-{{ this.Index + 1 }}">
    <a class="btn-view-card"></a>
  </label>

  <input type="checkbox" checked class="card-opcoes-card" id="card-opcoes-card-{{ this.Index + 1 }}"/>

  <label href="javascript:void(0)" for="card-opcoes-card-{{ this.Index + 1 }}">
    <a class="btn-opcoes-card"></a>
  </label>

  <div class="opcoes-card caixa-opcoes">

    <a *ngIf="this.userLogado?.funcionalidades?.includes(4) && this.Chamado.status === 0"
        href="javascript:void(0)"
        (click)="OnExcluirChamado(this.Chamado.codigoChamado)">
      Excluir
    </a>

    <a *ngIf="this.userLogado?.funcionalidades?.includes(3) && (this.Chamado.status === 0 || this.Chamado.status === 1 || this.Chamado.status === 2 || this.Chamado.status === 3) && this.Chamado.numeroBOSSP == null"
        href="javascript:void(0)"
        (click)="OnEditarChamado(this.Chamado.codigoChamado)">
      Alterar
    </a>

    <a *ngIf="!this.IsVisualizarChamado"
       href="javascript:void(0)"
       (click)="OnVisualizarChamado(this.Chamado.codigoChamado)">
      Visualizar
    </a>

    <a *ngIf="podeConcluirChamado(this.Chamado)"
        href="javascript:void(0)"
        (click)="AbrirModalConcluirChamado(this.Chamado.codigoChamado)"
    >
      Concluir
    </a>

    <a *ngIf="this.VerificaStatusEnvolvido() && (this.userLogado?.funcionalidades?.includes(5)) && this.TemEnvolvido"
        href="javascript:void(0)"
        (click)="AbrirModalEncerrarChamado(this.Chamado.codigoChamado, this.Chamado.codigoEnvolvido)">
      Encerra Chamado do Envolvido
    </a>

    <a *ngIf="((Chamado.aluno?.statusEnvolvido == 0) &&
               (this.userLogado?.funcionalidades?.includes(6) ||
                this.userLogado?.funcionalidades?.includes(7) ||
                this.userLogado?.funcionalidades?.includes(8))) && this.TemEnvolvido"
        href="javascript:void(0)"
        (click)="AbrirModalEncaminhamentos(this.Chamado.codigoChamado, this.Chamado.codigoEnvolvido)">
      Encaminhamento
    </a>

    <a *ngIf="this.userLogado?.funcionalidades?.includes(4) && this.Chamado.status === 4"
        href="javascript:void(0)"
        (click)="OnExcluirChamado(this.Chamado.codigoChamado)">
      Excluir chamado encerrado
    </a>

  </div>
</div>

<!-- Modal de Exclusão -->
<app-modal *ngIf="showModalExcluirChamado">
  <div class="container-conviva form-registro modal-envolvidos">
    <div>
      <h1 class="titulo-page">Chamado</h1>
    </div>
    <div class="descricao-modal-excluir">
      <span>{{this.descricaoExclusao}}</span>
    </div>
    <div class="container-btns">
      <input type="button" (click)="FecharModalExclusao()" class="btn_outline" value="Não"/>
      <input type="button" (click)="ExcluirChamado(this.chamadoARemover)" class="btn_primary" value="Sim" />
    </div>
  </div>
</app-modal>

<!-- Modal de Encerrar Chamado -->
<app-modal *ngIf="ShowModalEncerrarChamado">
  <div class="container-conviva form-registro modal-envolvidos">
    <div>
      <h1 class="titulo-page">Encerrar o Chamado do Envolvido</h1>
    </div>
    <div class="descricao-modal-excluir">
      <span >{{ this.descricaoConcluir }}</span>
    </div>
    <div class="container-btns">
      <input type="button" (click)="FecharModalEncerrarChamado()" class="btn_outline" value="Não"/>
      <input type="button" (click)="EncerrarChamado()" class="btn_primary" value="Sim"/>
    </div>
  </div>
</app-modal>

<!-- Modal de Encaminhamentos -->
<app-modal *ngIf="showModal">
  <div class="modal-encaminhamento-figma">
    <div class="header-modal-encaminhamento">
      <h1 class="titulo-encaminhamento">Tipo de encaminhamento</h1>
      <p class="subtitulo-encaminhamento">Para continuar, selecione o tipo de encaminhamento desejado</p>
    </div>

    <!-- Opções de Encaminhamento -->
    <div class="encaminhamento-opcoes-figma">
      <div class="row">
        <div class="col-sm-4" *ngIf="this.userLogado?.funcionalidades?.includes(6)" >
          <button
            id="btnEncPisicologo"
            type="button"
            (click)="PrepararEncaminhamento('psicologo')"
            class="btn-encaminhamento {{this.cssBtnPsicologo}}">
            <img src="../../../assets/img/icons/btn-enc-psicologo.svg" alt="" />
            <span>Psicólogo</span>
          </button>
        </div>
        
        <div class="col-sm-4" *ngIf="this.userLogado?.funcionalidades?.includes(7)">
          <button
            id="btnEncPolicia"
            type="button"
            (click)="PrepararEncaminhamento('rede-protetiva')"
            class="btn-encaminhamento {{this.cssBtnPolicia}}">
            <img src="../../../assets/img/icons/btn-enc-rede-protetiva.svg" alt="" />
            <span>Rede Protetiva</span>
          </button>
        </div>
        
        <div class="col-sm-4" *ngIf="this.userLogado?.funcionalidades?.includes(8)">
          <button
            id="btnEncHospitalar"
            type="button"              
            (click)="PrepararEncaminhamento('rede-hospitalar')"
            class="btn-encaminhamento {{this.cssBtnHospital}}">
            <img src="../../../assets/img/icons/btn-rede-hospitalar.svg" alt="" />
            <span>Rede Hospitalar</span>
          </button> 
        </div>
      </div>
    </div>

    <!-- Área de Anexos (apenas para Rede Protetiva) -->
    <div class="encaminhamento-anexos" *ngIf="tipoEncaminhamento === 'rede-protetiva'" >
      <div class="container">
          <div class="titulo">Selecione o tipo *</div>

          <label class="opcao">
              <input type="radio" name="encaminhamento" value="1" (change)="onChangeTEP(1)">
              <span>Encaminhamento para Conselho Tutelar</span>
          </label>

          <label class="opcao">
              <input type="radio" name="encaminhamento" value="2" (change)="onChangeTEP(2)">
              <span>Encaminhamento para Assistência Social</span>
          </label>

          <label class="opcao">
              <input type="radio" name="encaminhamento" value="3" (change)="onChangeTEP(3)">
              <span>Encaminhamento para Saúde</span>
          </label>
      </div>
      <div id="dvAlerta" class="msg-alerta" aria-live="polite" *ngIf="tipoEncaminhamento === 'rede-protetiva' && tipoEncaminhamentoPolicia == 0">
        Seleção obrigatória.
      </div>

      <br/>
      <h3 class="anexos-titulo">Deseja incluir anexos no encaminhamento?</h3>
      
      <div class="lista-arquivos" *ngIf="filesEncaminhamento.length > 0">
        <div class="arquivo-item" *ngFor="let arquivo of filesEncaminhamento; let i = index">
          <div class="arquivo-info">
            <i class="fa fa-paperclip"></i>
            <span class="arquivo-nome">{{ extraiNomeArquivoDaURLSemGuid(arquivo.nome) }}</span>
          </div>
          <button class="btn-excluir-arquivo" (click)="removerArquivoEncaminhamento(i)" title="Excluir">
            <i class="fa fa-trash"></i>
          </button>
        </div>
      </div>

      

      <div class="adicionar-arquivo">
        <input
          type="file"
          id="arquivosEncaminhamento"
          name="arquivosEncaminhamento"
          accept=".jpg, .jpeg, .png, .mp3, .mp4, .pdf"
          (change)="onFileChangeEncaminhamento($event)"
          class="file-input-hidden"
        />
        <label for="arquivosEncaminhamento" class="btn_outline btn-anexar">
          <i class="icon-paperclip"></i>
          Anexar arquivo
        </label>
      </div>
    </div>
      
    <!-- Botões de Ação -->
    <div class="container-btns">
      <input 
        type="button" 
        (click)="FecharModalEncaminhamentos()" 
        class="btn_outline" 
        value="Cancelar"
      />
      <input 
        type="button" 
        (click)="solicitarConfirmacaoEncaminhamento()" 
        class="btn_primary" 
        value="Confirmar"
        [disabled]="!tipoEncaminhamento"
      />
    </div>
  </div>
</app-modal>

<!-- Modal de Selecão de Envolvido para Encaminhar -->
<app-modal *ngIf="showModalSelecionarEnvolvidoEncaminhamento">
  <div class="modal-confirmar-encaminhamento">
    <div>
      <h1 class="titulo-page">Selecionar envolvido</h1>
    </div>
    <div class="descricao-modal-excluir">
      <span>O encaminhamento será realizado somente para o envolvido  selecionado.</span>
    </div>
    <br />
    <div class="item-envolvido" *ngFor="let envolvido of turmasEnvolvidos; let i = index">
      <label class="opcao-container">
        <input type="radio" name="encaminhamento" [value]="envolvido.codigoEnvolvido" (change)="onChangeEnvolvido($event)">
        
        <div class="info-envolvido">
          <span class="identificacao">{{envolvido.codigoEnvolvido}} - {{envolvido.nome}}</span>
          <span class="descricao">{{envolvido.dsEnvolvido}}</span>
        </div>
      </label>
    </div>
    <br/>

    <div class="container-btns">
      <input
        type="button"
        (click)="FecharModalEncaminhamentos()"
        class="btn_outline"
        value="Cancelar"
      />
      <input
        type="button"
        (click)="SelecionarVitima()"
        class="btn_primary"
        value="Confirmar"
      />
    </div>
  </div>
</app-modal>


<!-- Modal de Confirmação de Encaminhamento -->
<app-modal *ngIf="showModalConfirmarEncaminhamento">
  <div class="modal-confirmar-encaminhamento">
    <div>
      <h1 class="titulo-page">Confirmar encaminhamento</h1>
    </div>
    <div class="descricao-modal-excluir">
      <span>{{ mensagemConfirmacaoEncaminhamento }}</span>
    </div>
    <div class="container-btns">
      <input
        type="button"
        (click)="fecharModalConfirmacaoEncaminhamento()"
        class="btn_outline"
        value="Cancelar"
      />
      <input
        type="button"
        (click)="confirmarEncaminhamento()"
        class="btn_primary"
        value="Confirmar"
      />
    </div>
  </div>
</app-modal>

<!-- Modal de Sucesso do Encaminhamento -->
<app-modal *ngIf="showModalSucessoEncaminhamento">
  <div class="modal-sucesso-encaminhamento">
    <div class="icon-sucesso-container">
      <i class="icon-sucesso"></i>
    </div>
    <h1 class="titulo-sucesso">Encaminhamento realizado com sucesso</h1>
    <p class="mensagem-sucesso">{{ mensagemSucessoEncaminhamento }}</p>
    <div class="container-btns">
      <input
        type="button"
        (click)="fecharModalSucessoEncaminhamento()"
        class="btn_primary"
        value="OK"
      />
    </div>
  </div>
</app-modal>


<app-modal *ngIf="showModalConcluirChamado">
  <div class="container-conviva form-registro modal-envolvidos">
    <div>
      <h1 class="titulo-page">Concluir Chamado</h1>
    </div>
    <div class="descricao-modal-excluir">
      <span >{{ this.descricaoConcluir }}</span>

    </div>
    <div class="container-btns">
      <input
        type="button"
        (click)="FecharModalConcluir()"
        class="btn_outline"
        value="Não"
      />
      <input
        type="button"
        (click)="ConcluirChamado()"
        class="btn_primary"
        value="Sim"
      />
    </div>
  </div>
</app-modal>
